<form [formGroup]="addBOMToCartForm">
  <div class="row B-O-M-content small-font">
    <div class="col-md-1 center B-O-M-images">
      <mat-checkbox
        *ngIf="catalog"
        class="check-box"
        [checked]="!product.obsoleteProductFlag ? checked : false"
        [disabled]="product.obsoleteProductFlag"
        (change)="setChecked($event.checked)"
      >
      </mat-checkbox>
    </div>
    <div [ngClass]="loggedIn ? 'col-md-3' : 'col-md-4'">
      <div class="row">
        <cx-media
          class="B-O-M-images col-3"
          [container]="product.images"
          [alt]="product.summary"
        ></cx-media>
        <div class="col-9">
          <div class="top-part">
            <div>
              {{ "pdp.partNumbers" | cxTranslate }}
            </div>
            <a
              class="product-name"
              matTooltipClass="vs-tooltip"
              routerLink="{{ product?.url }}"
              [ngClass]="!catalog ? 'disabled-btn' : ''"
            >
              {{ product.code }}
            </a>
          </div>
          <div class="bottom-part">
            <div>
              {{ "pdp.partDescription" | cxTranslate }}
            </div>
            <a
              class="product-name"
              matTooltipClass="vs-tooltip"
              matTooltipPosition="right"
              [ngClass]="!catalog ? 'disabled-btn' : ''"
              matTooltip="{{ product?.name }}"
            >
              {{ product?.name }}
            </a>
          </div>
        </div>
      </div>
    </div>
    <div [ngClass]="loggedIn ? 'col-md-2' : 'col-md-3'">
      <div class="bold">
        {{ "pdp.quantity" | cxTranslate }}
      </div>
      <cx-item-counter
        [max]="9999"
        (itemCounter)="getCount($event)"
        [control]="addBOMToCartForm.get('quantity')"
      ></cx-item-counter>
      <div class="each">
        {{ "pdp.each" | cxTranslate }}
      </div>
    </div>
    <div
      *ngIf="loggedIn && product.price?.value && catalog"
      class="col-md-2 center bold mt-standard"
    >
      {{ product.price?.currencyIso }}
      {{
        product.price.value * count
          | currency: product.price?.currencyIso:"symbol":"1.2-2"
      }}
    </div>

    <!-- <div *ngIf="loggedIn && !product.price?.value" class="col-md-2 center bold mt-standard" matTooltipClass="vs-tooltip" matTooltipPosition="right" matTooltip="Price is not available for this product">Unavailable</div> -->

    <div
      *ngIf="!catalog || (loggedIn && !product.price?.value)"
      class="col-md-2 center bold mt-standard"
    >
      {{ "pdp.unavailable" | cxTranslate }}
    </div>

    <div class="col-md-4">
      <div
        class="available-at mt-standard"
        *ngIf="product?.obsoleteProductFlag"
      >
        <div class="small-font bold warning-text">
          {{ "pdp.obsoleteWarning" | cxTranslate }}
        </div>
      </div>
      <div class="available-at" *ngIf="!product.obsoleteProductFlag">
        <div class="small-font bold">{{ "pdp.availableAt" | cxTranslate }}</div>
        <ng-select
          [clearable]="false"
          [searchable]="false"
          [disabled]="true"
          placeholder='{{ "pdp.selectPlaceholder" | cxTranslate }}'
          (change)="changeProperty()"
          class="address"
          formControlName="availableAt"
        >
          <!-- <ng-option *ngFor="let availableAtLocation of availableAt" [value]="availableAtLocation">
                {{availableAtLocation?.salesOrganization}}
              </ng-option> -->
        </ng-select>
      </div>
    </div>
  </div>
</form>
